//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../Facet/Facet.SelectFacetedBodyList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AreBordersEnabled",1,0],[0,"AreRegionsEnabled",1,0],[1,"FacetBodies",0,"Facet.SelectFacetedBodyList",0],[0,"InputAction",1,0],[0,"IsSmoothingEnabled",1,0],[0,"MinimumBorderLength",1,0],[0,"SmoothingFactor",1,0]],[[["numberOfRegions"],"GetExtractedRegions",{R_:{regions:"Facet.FacetedBody[]"}},0,0],[["numberOfBorders"],"GetExtractedBorders",{R_:{borders:"Spline[]"}},0,0]],[]];
SPLM.Facet.FeatureExtractionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.FeatureExtractionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.FeatureExtractionBuilder.InputActions = Object.freeze({
    "Blank" : "Blank", "Retain" : "Retain", "Delete" : "Delete"});

export default SPLM;